import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import classnames from 'classnames';
import { unauthenticatedShipmentById } from '../../graphQL/queries/shipmentQueries';
import ErrorNotification from '../../components/common/ErrorNotification';
import LoadingIndicator from '../../components/LoadingIndicator';
import { AppContext } from '../../AppProvider';
import ShipmentStatus from '../../components/shipment/Status/Status';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';
import * as moment from 'moment';
import _last from 'lodash/last';
import _get from 'lodash/get';
import PoweredByImg from '../../images/powered_by_propel.png';

const styles = theme => ({
  poweredByLogo: {
    height: '40px',
    marginTop: theme.spacing.unit * 2
  },
  titleRowContainer: {
    display: 'flex',
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 2.5,
    alignItems: 'center'
  },
  containerContent: {
    marginTop: theme.spacing.unit * 3.5,
    paddingLeft: theme.spacing.unit * 5.25,
    paddingRight: theme.spacing.unit * 5.875,
    paddingBottom: theme.spacing.unit * 5
  }
});

class ShipmentTracking extends Component {
  state = { shipment: {}, loading: true };

  async componentDidMount() {
    const {
      client,
      match: {
        params: { id }
      }
    } = this.props;

    const {
      data: {
        unauthenticated: { shipment }
      }
    } = await client.query({
      query: unauthenticatedShipmentById,
      variables: { id }
    });

    shipment.pickup = shipment.stops[0];
    shipment.delivery = _last(shipment.stops);

    this.setState({
      shipment,
      loading: false
    });
  }

  render() {
    const { shipment, loading, error } = this.state;
    const { classes, t } = this.props;

    if (loading) {
      return <LoadingIndicator />;
    }

    if (error) {
      return <ErrorNotification message={error} />;
    }

    return (
      !loading && (
        <Grid container spacing={0} justify="center" alignItems="center">
          <Grid item xs={4}>
            <div className={classes.headline6}>
              <h1>
                {t('Shipment')} #{shipment.id}
              </h1>
            </div>
          </Grid>
          <Grid item xs={6} align="right">
            <div className={classes.body1Light}>
              <h3>
                {t('Last Updated')}{' '}
                {moment(shipment.changed).format('MMMM D, YYYY @ h:mm A')}
              </h3>
            </div>
          </Grid>
          <Grid item xs={10}>
            <ShipmentStatus
              shipment={shipment}
              editable={false}
              isAuthenticated={false}
            />
          </Grid>
          <Grid item xs={10}>
            <div className={classnames(classes.root, classes.container)}>
              <div
                className={classnames(
                  classes.titleContentDivider,
                  classes.titleRowContainer
                )}
              >
                <h2 className={classnames(classes.headline8)}>
                  {t('Carrier Information')}
                </h2>
              </div>
              <div className={classes.containerContent}>
                <Grid container spacing={8}>
                  <Grid item xs={4}>
                    <div className={classes.headline7}>{t('Carrier Name')}</div>
                    <div className={classes.body2}>
                      {_get(
                        shipment,
                        'selectedShipmentRate.carrier.name',
                        null
                      ) ||
                        _get(
                          shipment,
                          'selectedShipmentRate.carrierName',
                          null
                        ) ||
                        'N/A'}
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={classes.headline7}>{t('PRO Number')}</div>
                    <div className={classes.body2}>
                      {_get(shipment, 'proNumber', null) || 'N/A'}
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={classes.headline7}>
                      {t('Customer Service')}
                    </div>
                    <div className={classes.body2}>
                      {_get(
                        shipment,
                        'selectedShipmentRate.carrier.customerServicePhoneNumber',
                        null
                      ) || 'N/A'}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
          <Grid item xs={10} align="center">
            <div className={classes.divider} />
            <div>
              <img
                src={PoweredByImg}
                alt={t('Powered By Propel')}
                className={classes.poweredByLogo}
              />
            </div>
          </Grid>
        </Grid>
      )
    );
  }
}

ShipmentTracking.contextType = AppContext;
const translatedShipmentTracking = withNamespaces()(ShipmentTracking);
export default withStyles(
  combineStyles(
    styles,
    TypographyStyles,
    SpacingStyles,
    LayoutStyles,
    FormItemContainerStyles
  )
)(withApollo(translatedShipmentTracking));
